import { forwardRef } from 'react';
import { Trans } from 'react-i18next';
import { cn } from '@/lib/utils';

interface Props extends React.ButtonHTMLAttributes<HTMLParagraphElement> {
  i18nKey: string;
}

const Text = forwardRef<HTMLParagraphElement, Props>(
  ({ i18nKey, className, ...props }, ref) => {
    return (
      <p
        ref={ref}
        className={cn('whitespace-pre-wrap text-white', className)}
        {...props}
      >
        <Trans
          i18nKey={i18nKey}
          components={{
            li: <li className="-mb-6 pt-2 font-bold text-secondary" />,
            b: (
              <span className="font-bold text-secondary">
                <strong />
              </span>
            ),
          }}
        />
      </p>
    );
  }
);
Text.displayName = 'Text';
export default Text;
